<template>
  <d-modal
    v-if="isVisible"
    @close="cancel"
    size="lg">
    <d-modal-header>
      <d-modal-title>
        <template v-if="mode === 'add'">
          Add note
        </template>
        <template v-if="mode === 'edit'">
          Update note
        </template>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div class="form-group">
        <label for="date">Date:</label>
        <d-datepicker
          v-model="date"
          format="yyyy-MM-dd"
          placeholder="Select a date" />
      </div>
      <div class="form-group color-selector">
        <label for="note">Color:</label>

        <d-button-group size="small" class="d-block">
          <d-button
            theme="light"
            style="background: #007bff;"
            @click.prevent="setColor('#007bff')"
            class="text-center">
            <i
              :style="color === '#007bff' ? 'color: #fff; transform: scale(2);' : 'color: #007bff;'"
              class="material-icons">check</i>
          </d-button>
          <d-button
            theme="light"
            style="background: #28a745;"
            @click.prevent="setColor('#28a745')">
            <i
              :style="color === '#28a745' ? 'color: #fff; transform: scale(2);' : 'color: #28a745;'"
              class="material-icons">check</i>
          </d-button>
          <d-button
            theme="light"
            style="background: #20c997;"
            @click.prevent="setColor('#20c997')">
            <i
              :style="color === '#20c997' ? 'color: #fff; transform: scale(2);' : 'color: #20c997;'"
              class="material-icons">check</i>
          </d-button>
          <d-button
            theme="light"
            style="background: #ffc107;"
            @click.prevent="setColor('#ffc107')">
            <i
              :style="color === '#ffc107' ? 'color: #fff; transform: scale(2);' : 'color: #ffc107;'"
              class="material-icons">check</i>
          </d-button>
          <d-button
            theme="light"
            style="background: #fd7e14;"
            @click.prevent="setColor('#fd7e14')">
            <i
              :style="color === '#fd7e14' ? 'color: #fff; transform: scale(2);' : 'color: #fd7e14;'"
              class="material-icons">check</i>
          </d-button>
          <d-button
            theme="light"
            style="background: #dc3545;"
            @click.prevent="setColor('#dc3545')">
            <i
              :style="color === '#dc3545' ? 'color: #fff; transform: scale(2);' : 'color: #dc3545;'"
              class="material-icons">check</i>
          </d-button>
          <d-button
            theme="light"
            style="background: #6610f2;"
            @click.prevent="setColor('#6610f2')">
            <i
              :style="color === '#6610f2' ? 'color: #fff; transform: scale(2);' : 'color: #6610f2;'"
              class="material-icons">check</i>
          </d-button>
        </d-button-group>
      </div>
      <div class="form-group">
        <label for="note">Content:</label>
        <wysiwyg
          v-model="note"></wysiwyg>
      </div>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        theme="danger"
        :disabled="submitInProgress"
        @click.prevent="cancel">
        Cancel
      </d-button>
      <d-button
        theme="success"
        class="ml-auto"
        :disabled="submitInProgress"
        @click.prevent="save">
        <template v-if="mode === 'add'">
          Save note
        </template>
        <template v-if="mode === 'edit'">
          Update note
        </template>
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import Vue from 'vue';

export default {
  name: 'calendar-note-popup',
  data () {
    return {
      isVisible: false,
      mode: 'add',
      id: 0,
      color: '',
      note: '',
      date: '',
      submitInProgress: false
    };
  },
  mounted () {
    this.$bus.$on('calendar-note-popup-show', this.showPopup);
  },
  methods: {
    showPopup (itemData = false) {
      this.isVisible = true;

      if (!itemData || !itemData.id) {
        this.mode = 'add';
        this.id = 0;
        this.color = '';
        this.note = '';
        this.date = itemData.date ? itemData.date : new Date();
      } else {
        this.mode = 'edit';
        this.id = itemData.id;
        this.color = itemData.color;
        this.note = itemData.note;
        this.date = itemData.date;
      }
    },
    setColor (newColor) {
      this.color = newColor;
    },
    cancel () {
      this.isVisible = false;
    },
    save () {
      let dateToSave = this.date;
      let dataToSend;
      let endpointUrl = '/notes/store';

      if (this.id) {
        endpointUrl = '/notes/update/' + parseInt(this.id, 10);
      }

      if (typeof this.date !== 'string') {
        dateToSave = [this.date.getFullYear(), this.date.getMonth() + 1, this.date.getDate()].map(n => n < 10 ? '0' + n : n).join('-');
      }

      dataToSend = {
        color: this.color,
        date: dateToSave,
        note: this.note
      };

      FormUtils.submitInBackground({
        $http: this.$http,
        formData: dataToSend,
        endpoint: endpointUrl,
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during saving the note. Please try again',
        successAction: () => {
          Vue.swal({
            title: 'Success',
            html: 'Note has been saved',
            icon: 'success',
            confirmButtonText: 'OK',
            buttonsStyling: true,
            timer: 1000,
            timerProgressBar: true
          });

          this.submitInProgress = false;
          this.cancel();
          this.$bus.$emit('calendar-notes-update');
        },
        failAction: () => {
          this.submitInProgress = false;
        }
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('calendar-note-popup-show', this.showPopup);
  }
}
</script>

<style lang="scss" scoped>

</style>
